import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FUIFormationService} from "../../formation.service";
import {AbstractControl, FormGroup} from "@angular/forms";
import {Subscription} from "rxjs";
import {FUIFormationType} from "../../formation.type";
import {FUIResponsiveService} from "../../../../page/responsive.service";

@Component({
    selector: "fui-formation-group",
    styleUrls: ["./formation-group.component.scss"],
    templateUrl: "./formation-group.component.html"
})
export class FUIFormationGroupComponent implements OnInit, OnDestroy  {
    @Input() public title: string;
    @Input() formationType: FUIFormationType;
    @Input() startActive: boolean = false;
    private _formControls: AbstractControl[] = [];
    public isInvalid: boolean;
    private formSubmitted: boolean;
    private formControlsSubscription: Subscription = new Subscription();
    public isActive: boolean;
    // defines if the group has been active at least once
    public hasLoaded: boolean;

    subscriptions: Subscription = new Subscription();

    constructor(private changeDetectorRef: ChangeDetectorRef,
                private formationService: FUIFormationService,
                private responsiveService: FUIResponsiveService) {
    }

    ngOnInit(): void {
        this.formationService.registerGroup(this);
        this.subscriptions.add(this.formationService.initialised$.subscribe((initialised) => {
            if (initialised && (this.startActive || !this.isCollapsible)) {
                this.isActive = true;
                this.hasLoaded = true;
                if (this.isCollapsible) {
                    this.formationService.setActiveGroup(this);
                }
                this.changeDetectorRef.detectChanges();
            }
        }));
        this.subscriptions.add(this.formationService.group$.subscribe((group) => {
            if (this.isCollapsible) {
                this.isActive = this.effectiveFormationType === FUIFormationType.ACCORDION ? this === group : (this.isActive || this === group);
            }
            this.hasLoaded = this.hasLoaded || this.isActive;
            this.changeDetectorRef.detectChanges();
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.formControlsSubscription.unsubscribe();
    }

    get formControls(): AbstractControl[] {
        return this._formControls;
    }

    @Input()
    set formControlNames(value: string[] | string) {
        if (value == undefined) {
            return;
        }
        this._formControls = [];
        if (Array.isArray(value)) {
            value.forEach((item) => this._formControls.push(...this.resolveFormControl(item)));
        } else {
            this._formControls.push(...this.resolveFormControl(value));
        }
        this._formControls.forEach((formControl) => {
            this.formControlsSubscription.add(formControl.statusChanges.subscribe(() => {
                this.evaluateInvalid();
            }));
        });
        if (this.formationService.formSubmitted) {
            this.formControlsSubscription.add(this.formationService.formSubmitted.subscribe((submitted) => {
                this.formSubmitted = submitted;
                this.evaluateInvalid();
            }));
        }
    }

    private evaluateInvalid(): void {
        this.isInvalid = this._formControls.filter((item) => (item.dirty || this.formSubmitted) && item.errors !== null).length !== 0;
    }

    private resolveFormControl(formControlName: string): AbstractControl[] {
        let formControl: AbstractControl = formControlName === "" ? this.formationService.formGroupValidation : this.formationService.formGroupValidation.get(formControlName);
        if (formControl === null) {
            console.log("Cannot find form control " + formControlName);
            return [];
        } else if (formControl instanceof FormGroup) {
            return this.formationService.formGroupResolver(formControl);
        } else {
            return [formControl];
        }
    }

    /**
     * Load the group
     */
    load(): void {
        this.hasLoaded = true;
    }

    toggle(): void {
        if (this.isCollapsible) {
            this.isActive = !this.isActive;
            this.formationService.setActiveGroup(!this.isActive ? null : this);
            setTimeout(() => this.responsiveService.emitWindowWidthChange());
        }
    }

    get isCollapsible(): boolean {
        return this.effectiveFormationType === FUIFormationType.ACCORDION || this.effectiveFormationType === FUIFormationType.COLLAPSIBLE;
    }

    get effectiveFormationType(): FUIFormationType {
        return this.formationType != undefined ? this.formationType : this.formationService.formationType;
    }
}
